import { axios } from '@/utils/request'

// 获取购物车数据params
export function getCart() {
  return axios({
    url: '/distribution/cart',
    method: 'GET'
  })
}
// 购物车详情列表
export function getCartItem(params) {
  return axios({
    url: '/distribution/cartItem',
    method: 'GET',
    params
  })
}
// 添加购物车详情
export function addCartItem(data) {
  return axios({
    url: '/distribution/cartItem',
    method: 'POST',
    data
  })
}
// 批量添加购物车
export function batchAddCart(data) {
  return axios({
    url: '/distribution/cartItem/addCartItems',
    method: 'POST',
    data
  })
}
// 更改购物车详情列表
export function putCartItem(data, id) {
  return axios({
    url: '/distribution/cartItem/' + id,
    method: 'PUT',
    data
  })
}
// 删除购物车详情
export function deCartItem(id) {
  return axios({
    url: '/distribution/cartItem/' + id,
    method: 'DELETE'
  })
}
// 获取购物车项可选物流
export function getLogistics(params) {
  return axios({
    url: '/distribution/cartItem/logistics',
    method: 'GET',
    params
  })
}
// 生成订单
export function createOrder(data) {
  return axios({
    url: '/distribution/cartItem/createOrder',
    method: 'POST',
    data
  })
}
// 预览产品价格
export function getShowPrice(params) {
  return axios({
    url: '/distribution/cartItem/showPrice',
    method: 'GET',
    params
  })
}

// 添加购物车
export function addCartItems(data) {
  return axios({
    url: '/distribution/cartItem/addCartItems',
    method: 'POST',
    data
  })
}
// 修改购物车数量
export function batchPutCartItem(data) {
  return axios({
    url: '/distribution/cartItem',
    method: 'POST',
    data
  })
}
// 获取生成FBA订单数据
export function getCartItemList(params) {
  return axios({
    url: '/distribution/cartItem',
    method: 'GET',
    params
  })
}
// 获取购物车批发价获取
export function getFbaWholesalePrice(data) {
  return axios({
    url: '/distribution/cartItem/fbaWholesalePrice',
    method: 'POST',
    data
  })
}
// 批量更新购物车产品数量
export function multiUpdateCartInfo(data) {
  return axios({
    url: '/distribution/cartItem/multiUpdateCartInfo',
    method: 'POST',
    data
  })
}
// 批量更新购物车产品数量
export function checkCartItems(data) {
  return axios({
    url: '/distribution/cartItem/checkCartItems',
    method: 'POST',
    data
  })
}
// 判断是否展
export function pickupAble(data) {
  return axios({
    url: '/distribution/cartItem/pickupAble',
    method: 'POST',
    data
  })
}
// 复制购物车项
export function copyCartItem(data) {
  return axios({
    url: '/distribution/cartItem/copy',
    method: 'POST',
    data
  })
}
// 获取勾取价格
export function choicePrice(params) {
  return axios({
    url: '/distribution/cartItem/choicePrice',
    method: 'GET',
    params
  })
}

// 设置品牌
export function setBrands(data) {
  return axios({
    url: '/distribution/cartItem/setBrands',
    method: 'POST',
    data
  })
}
